import { toast } from 'react-toastify'
import { postCPDataWithParams } from 'src/clinic/services'
import { DISPATCH_EVENT_KEYS } from 'src/consumer/constants'
import { isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'
import { getEventTypesFromRoomData } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingsHelper'
import { broadcastCheckInUpdate, updateCheckInWithValidation, broadcastCheckInRemoval } from './checkInSyncService'
import { getClientDeviceInfo } from 'src/consumer/services/deviceInfoCollector'

export async function checkIntoRoom(roomData) {
  console.log(roomData)
  const clientDeviceInfo = getClientDeviceInfo()
  const response = await postCPDataWithParams(
    `/api/secure/teacher/emr/usage/log/checkin`,
    {
      selectedCheckInEventOption: roomData?.selectedCheckinEventOption,
      checkinMethod: roomData?.checkinMethod,
      clinicBrandId: roomData?.clinicBrandId,
      clinicLocationId: roomData?.clinicLocationId,
      chamberRoomId: roomData?.id,
      apiParam: 'emr-usage-log',
      clientDeviceInfo,
    },
    {},
  )

  if (response?.status === 200) {
    if (isCommonResponseSuccessfulV2(response)) {
      window.dispatchEvent(
        new CustomEvent(DISPATCH_EVENT_KEYS.userCheckedIn, {
          detail: {
            roomData: response?.data?.data?.['chamber-room'],
            usageLog: response?.data?.data?.['emr-usage-log'],
          },
        }),
      )
    } else {
      console.error('error', response?.data?.message)
      toast.error(response?.data?.message || 'Could not check in')
    }
  } else {
    console.error('error', response.message)
    toast.error('Could not check in')
  }
  return response
}

export async function checkIntoRoomWithLocalStorageApplied(roomData) {
  const resp = await checkIntoRoom(roomData)
  if (resp?.status === 200) {
    const emrUsageLog = resp?.data?.data?.['emr-usage-log']
    const chamberRoom = resp?.data?.data?.['chamber-room']
    
    if (emrUsageLog) {
      // Update with validation timestamp and broadcast to other tabs
      updateCheckInWithValidation(emrUsageLog)
      broadcastCheckInUpdate(emrUsageLog, chamberRoom)
    }
    
    if (chamberRoom) {
      localStorage.setItem('peekedInRoomDetails', JSON.stringify(chamberRoom))
    }
    
    // Extract and store eventTypes from roomData
    if (chamberRoom?.checkInEventOptions) {
      const eventTypes = getEventTypesFromRoomData(
        chamberRoom.checkInEventOptions,
        [], // mentorEventTypes not available here, will be matched later
        chamberRoom?.clinicLocationId
      )
      if (eventTypes.length > 0) {
        localStorage.setItem('roomDataEventTypes', JSON.stringify(eventTypes))
        console.log('[checkIntoRoomWithLocalStorageApplied] Stored roomDataEventTypes:', eventTypes.length, 'event types')
      }
    }
  }
}

export async function peekIntoRoom(roomData) {
  console.log(roomData)
  const response = await postCPDataWithParams(
    `/api/secure/teacher/emr/usage/log/events`,
    {
      clinicBrandId: roomData?.clinicBrandId,
      clinicLocationId: roomData?.clinicLocationId,
      chamberRoomId: roomData?.id,
      logEventId: 'enter-without-checkin',
      apiParam: 'emr-usage-log',
    },
    {},
  )
  return response
}

export async function peekOutFromRoom(roomData) {
  console.log(roomData)
  const response = await postCPDataWithParams(
    `/api/secure/teacher/emr/usage/log/events`,
    {
      selectedCheckInEventOption: roomData?.selectedCheckinEventOption,
      clinicBrandId: roomData?.clinicBrandId,
      clinicLocationId: roomData?.clinicLocationId,
      chamberRoomId: roomData?.id,
      logEventId: 'peek-out',
      apiParam: 'emr-usage-log',
    },
    {},
  )
  return response
}
export async function logJoinAuditRoom(roomData) {
  console.log(roomData)
  const response = await postCPDataWithParams(
    `/api/secure/teacher/emr/usage/log/events`,
    {
      selectedCheckInEventOption: roomData?.selectedCheckinEventOption,
      clinicBrandId: roomData?.clinicBrandId,
      clinicLocationId: roomData?.clinicLocationId,
      chamberRoomId: roomData?.id,
      logEventId: 'audit-checkin',
      apiParam: 'emr-usage-log',
    },
    {},
  )
  return response
}
export async function logLeaveAuditRoom(roomData) {
  console.log(roomData)
  const response = await postCPDataWithParams(
    `/api/secure/teacher/emr/usage/log/events`,
    {
      selectedCheckInEventOption: roomData?.selectedCheckinEventOption,
      clinicBrandId: roomData?.clinicBrandId,
      clinicLocationId: roomData?.clinicLocationId,
      chamberRoomId: roomData?.id,
      logEventId: 'audit-checkout',
      apiParam: 'emr-usage-log',
    },
    {},
  )
  return response
}
export async function logMentorIdle(roomData) {
  console.log(roomData)
  const response = await postCPDataWithParams(
    `/api/secure/teacher/emr/usage/log/events`,
    {
      selectedCheckInEventOption: roomData?.selectedCheckinEventOption,
      clinicBrandId: roomData?.clinicBrandId,
      clinicLocationId: roomData?.clinicLocationId,
      chamberRoomId: roomData?.id,
      logEventId: 'log-screen-idle',
      apiParam: 'emr-usage-log',
    },
    {},
  )
  return response
}

export async function refreshCheckIntoRoom(roomData) {
  console.log(roomData)
  const clientDeviceInfo = getClientDeviceInfo()
  const response = await postCPDataWithParams(
    `/api/secure/teacher/emr/usage/log/checkin-refresh`,
    {
      selectedCheckInEventOption: roomData?.selectedCheckinEventOption,
      checkinMethod: roomData?.checkinMethod,
      clinicBrandId: roomData?.clinicBrandId,
      clinicLocationId: roomData?.clinicLocationId,
      chamberRoomId: roomData?.chamberRoomId,
      apiParam: 'emr-usage-log',
      clientDeviceInfo,
    },
    {},
  )

  if (response?.status === 200) {
    window.dispatchEvent(
      new CustomEvent(DISPATCH_EVENT_KEYS.userRefreshCheckedIn, {
        detail: {
          roomData: response?.data?.data?.['chamber-room'],
          usageLog: response?.data?.data?.['emr-usage-log'],
        },
      }),
    )
  }
  return response
}

export async function presentInRoom(roomData) {
  console.log(roomData)
  const response = await postCPDataWithParams(
    `/api/secure/teacher/emr/usage/log/events`,
    {
      selectedCheckInEventOption: roomData?.selectedCheckinEventOption,
      clinicBrandId: roomData?.clinicBrandId,
      clinicLocationId: roomData?.clinicLocationId,
      chamberRoomId: roomData?.id,
      logEventId: 'presence-detected',
      apiParam: 'emr-usage-log',
    },
    {},
  )
  return response
}

export async function refreshCheckIntoRoomWithLocalStorageApplied(roomData) {
  const resp = await refreshCheckIntoRoom(roomData)
  if (resp?.status === 200 && isCommonResponseSuccessfulV2(resp)) {
    const emrUsageLog = resp?.data?.data?.['emr-usage-log']
    const chamberRoom = resp?.data?.data?.['chamber-room']

    if (!!emrUsageLog) {
      // Update with validation timestamp and broadcast to other tabs
      updateCheckInWithValidation(emrUsageLog)
      broadcastCheckInUpdate(emrUsageLog, chamberRoom)
    }
    
    if (!!chamberRoom) {
      localStorage.setItem('peekedInRoomDetails', JSON.stringify(chamberRoom))
      
      // Extract and store eventTypes from roomData
      if (chamberRoom?.checkInEventOptions) {
        const eventTypes = getEventTypesFromRoomData(
          chamberRoom.checkInEventOptions,
          [], // mentorEventTypes not available here, will be matched later
          chamberRoom?.clinicLocationId
        )
        if (eventTypes.length > 0) {
          localStorage.setItem('roomDataEventTypes', JSON.stringify(eventTypes))
          console.log('[refreshCheckIntoRoomWithLocalStorageApplied] Stored roomDataEventTypes:', eventTypes.length, 'event types')
        }
      }
    }
  }
}

export async function checkOutRoom(emrUsageLog, checkinRequestData = null) {
  console.log(emrUsageLog)
  const params = {
    clinicLocationId: emrUsageLog?.clinicLocationId,
    clinicBrandId: emrUsageLog?.clinicBrandId,
    chamberRoomId: emrUsageLog?.chamberRoomId,
    apiParam: 'emr-usage-log',
  }

  // Add checkin request data if provided
  if (checkinRequestData) {
    params.checkinRequestMentorId = checkinRequestData.mentorId
    params.checkinRequestReason = checkinRequestData.reason
    params.checkinRequestId = checkinRequestData.requestId
  }

  const response = await postCPDataWithParams(
    `/api/secure/teacher/emr/usage/log/checkout`,
    params,
    {},
  )
  if (response?.status === 200) {
    // Remove from localStorage and broadcast to other tabs
    localStorage.removeItem('checkedInDetails')
    localStorage.removeItem('peekedInRoomDetails')
    localStorage.removeItem('roomDataEventTypes')
    broadcastCheckInRemoval()
    
    window.dispatchEvent(
      new CustomEvent(DISPATCH_EVENT_KEYS.userCheckedOut, {
        detail: {},
      }),
    )
  }
  return response
}

/**
 * Log a checkin request as ignored
 * @param {Object} roomData - Room data containing clinic and chamber room information
 * @param {Object} checkinRequestData - Checkin request data
 * @param {string} checkinRequestData.mentorId - ID of the mentor who requested checkin
 * @param {string} checkinRequestData.reason - Reason for the checkin request
 * @param {string} checkinRequestData.requestId - Unique ID for this checkin request
 */
export async function logCheckinRequestIgnored(roomData, checkinRequestData) {
  console.log('Logging checkin request ignored', { roomData, checkinRequestData })
  const response = await postCPDataWithParams(
    `/api/secure/teacher/emr/usage/log/events`,
    {
      clinicBrandId: roomData?.clinicBrandId,
      clinicLocationId: roomData?.clinicLocationId,
      chamberRoomId: roomData?.chamberRoomId || roomData?.id,
      logEventId: 'checkin-request-ignored',
      apiParam: 'emr-usage-log',
      checkinRequestMentorId: checkinRequestData?.mentorId,
      checkinRequestReason: checkinRequestData?.reason,
      checkinRequestId: checkinRequestData?.requestId,
    },
    {},
  )
  return response
}
